import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-billing-report-filter',
  templateUrl: './billing-report-filter.component.html',
  styleUrls: ['./billing-report-filter.component.scss']
})
export class BillingReportFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
